import { render, staticRenderFns } from "./abilityManager.vue?vue&type=template&id=58674d4c"
import script from "./abilityManager.vue?vue&type=script&lang=js"
export * from "./abilityManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports